export default __webpack_public_path__ + "static/media/graph.e0673a46.png";